export default "__VITE_ASSET__DwtbYl80__"